export var StrategyAttributeCountryName;
(function (StrategyAttributeCountryName) {
    StrategyAttributeCountryName["Afghanistan"] = "afghanistan";
    StrategyAttributeCountryName["Albania"] = "albania";
    StrategyAttributeCountryName["Algeria"] = "algeria";
    StrategyAttributeCountryName["Andorra"] = "andorra";
    StrategyAttributeCountryName["Angola"] = "angola";
    StrategyAttributeCountryName["AntiguaAndBarbuda"] = "antigua_and_barbuda";
    StrategyAttributeCountryName["Argentina"] = "argentina";
    StrategyAttributeCountryName["Armenia"] = "armenia";
    StrategyAttributeCountryName["Australia"] = "australia";
    StrategyAttributeCountryName["Austria"] = "austria";
    StrategyAttributeCountryName["Azerbaijan"] = "azerbaijan";
    StrategyAttributeCountryName["TheBahamas"] = "the_bahamas";
    StrategyAttributeCountryName["Bahrain"] = "bahrain";
    StrategyAttributeCountryName["Bangladesh"] = "bangladesh";
    StrategyAttributeCountryName["Barbados"] = "barbados";
    StrategyAttributeCountryName["Belarus"] = "belarus";
    StrategyAttributeCountryName["Belgium"] = "belgium";
    StrategyAttributeCountryName["Belize"] = "belize";
    StrategyAttributeCountryName["Benin"] = "benin";
    StrategyAttributeCountryName["Bhutan"] = "bhutan";
    StrategyAttributeCountryName["Bolivia"] = "bolivia";
    StrategyAttributeCountryName["BosniaAndHerzegovina"] = "bosnia_and_herzegovina";
    StrategyAttributeCountryName["Botswana"] = "botswana";
    StrategyAttributeCountryName["Brazil"] = "brazil";
    StrategyAttributeCountryName["Brunei"] = "brunei";
    StrategyAttributeCountryName["Bulgaria"] = "bulgaria";
    StrategyAttributeCountryName["BurkinaFaso"] = "burkina_faso";
    StrategyAttributeCountryName["Burundi"] = "burundi";
    StrategyAttributeCountryName["CaboVerde"] = "cabo_verde";
    StrategyAttributeCountryName["Cambodia"] = "cambodia";
    StrategyAttributeCountryName["Cameroon"] = "cameroon";
    StrategyAttributeCountryName["Canada"] = "canada";
    StrategyAttributeCountryName["CentralAfricanRepublic"] = "central_african_republic";
    StrategyAttributeCountryName["Chad"] = "chad";
    StrategyAttributeCountryName["Chile"] = "chile";
    StrategyAttributeCountryName["China"] = "china";
    StrategyAttributeCountryName["Colombia"] = "colombia";
    StrategyAttributeCountryName["Comoros"] = "comoros";
    StrategyAttributeCountryName["CongoDemocraticRepublicOfThe"] = "congo_democratic_republic_of_the";
    StrategyAttributeCountryName["CongoRepublicOfThe"] = "congo_republic_of_the";
    StrategyAttributeCountryName["CostaRica"] = "costa_rica";
    StrategyAttributeCountryName["CoteDivoire"] = "cote_divoire";
    StrategyAttributeCountryName["Croatia"] = "croatia";
    StrategyAttributeCountryName["Cuba"] = "cuba";
    StrategyAttributeCountryName["Cyprus"] = "cyprus";
    StrategyAttributeCountryName["CzechRepublic"] = "czech_republic";
    StrategyAttributeCountryName["Denmark"] = "denmark";
    StrategyAttributeCountryName["Djibouti"] = "djibouti";
    StrategyAttributeCountryName["Dominica"] = "dominica";
    StrategyAttributeCountryName["DominicanRepublic"] = "dominican_republic";
    StrategyAttributeCountryName["EastTimor"] = "east_timor";
    StrategyAttributeCountryName["Ecuador"] = "ecuador";
    StrategyAttributeCountryName["Egypt"] = "egypt";
    StrategyAttributeCountryName["ElSalvador"] = "el_salvador";
    StrategyAttributeCountryName["EquatorialGuinea"] = "equatorial_guinea";
    StrategyAttributeCountryName["Eritrea"] = "eritrea";
    StrategyAttributeCountryName["Estonia"] = "estonia";
    StrategyAttributeCountryName["Eswatini"] = "eswatini";
    StrategyAttributeCountryName["Ethiopia"] = "ethiopia";
    StrategyAttributeCountryName["Fiji"] = "fiji";
    StrategyAttributeCountryName["Finland"] = "finland";
    StrategyAttributeCountryName["France"] = "france";
    StrategyAttributeCountryName["Gabon"] = "gabon";
    StrategyAttributeCountryName["TheGambia"] = "the_gambia";
    StrategyAttributeCountryName["Georgia"] = "georgia";
    StrategyAttributeCountryName["Germany"] = "germany";
    StrategyAttributeCountryName["Ghana"] = "ghana";
    StrategyAttributeCountryName["Greece"] = "greece";
    StrategyAttributeCountryName["Grenada"] = "grenada";
    StrategyAttributeCountryName["Guatemala"] = "guatemala";
    StrategyAttributeCountryName["Guinea"] = "guinea";
    StrategyAttributeCountryName["GuineaBissau"] = "guinea_bissau";
    StrategyAttributeCountryName["Guyana"] = "guyana";
    StrategyAttributeCountryName["Haiti"] = "haiti";
    StrategyAttributeCountryName["Honduras"] = "honduras";
    StrategyAttributeCountryName["Hungary"] = "hungary";
    StrategyAttributeCountryName["Iceland"] = "iceland";
    StrategyAttributeCountryName["India"] = "india";
    StrategyAttributeCountryName["Indonesia"] = "indonesia";
    StrategyAttributeCountryName["Iran"] = "iran";
    StrategyAttributeCountryName["Iraq"] = "iraq";
    StrategyAttributeCountryName["Ireland"] = "ireland";
    StrategyAttributeCountryName["Israel"] = "israel";
    StrategyAttributeCountryName["Italy"] = "italy";
    StrategyAttributeCountryName["Jamaica"] = "jamaica";
    StrategyAttributeCountryName["Japan"] = "japan";
    StrategyAttributeCountryName["Jordan"] = "jordan";
    StrategyAttributeCountryName["Kazakhstan"] = "kazakhstan";
    StrategyAttributeCountryName["Kenya"] = "kenya";
    StrategyAttributeCountryName["Kiribati"] = "kiribati";
    StrategyAttributeCountryName["KoreaNorth"] = "korea_north";
    StrategyAttributeCountryName["KoreaSouth"] = "korea_south";
    StrategyAttributeCountryName["Kosovo"] = "kosovo";
    StrategyAttributeCountryName["Kuwait"] = "kuwait";
    StrategyAttributeCountryName["Kyrgyzstan"] = "kyrgyzstan";
    StrategyAttributeCountryName["Laos"] = "laos";
    StrategyAttributeCountryName["Latvia"] = "latvia";
    StrategyAttributeCountryName["Lebanon"] = "lebanon";
    StrategyAttributeCountryName["Lesotho"] = "lesotho";
    StrategyAttributeCountryName["Liberia"] = "liberia";
    StrategyAttributeCountryName["Libya"] = "libya";
    StrategyAttributeCountryName["Liechtenstein"] = "liechtenstein";
    StrategyAttributeCountryName["Lithuania"] = "lithuania";
    StrategyAttributeCountryName["Luxembourg"] = "luxembourg";
    StrategyAttributeCountryName["Madagascar"] = "madagascar";
    StrategyAttributeCountryName["Malawi"] = "malawi";
    StrategyAttributeCountryName["Malaysia"] = "malaysia";
    StrategyAttributeCountryName["Maldives"] = "maldives";
    StrategyAttributeCountryName["Mali"] = "mali";
    StrategyAttributeCountryName["Malta"] = "malta";
    StrategyAttributeCountryName["MarshallIslands"] = "marshall_islands";
    StrategyAttributeCountryName["Mauritania"] = "mauritania";
    StrategyAttributeCountryName["Mauritius"] = "mauritius";
    StrategyAttributeCountryName["Mexico"] = "mexico";
    StrategyAttributeCountryName["MicronesiaFederatedStatesOf"] = "micronesia_federated_states_of";
    StrategyAttributeCountryName["Moldova"] = "moldova";
    StrategyAttributeCountryName["Monaco"] = "monaco";
    StrategyAttributeCountryName["Mongolia"] = "mongolia";
    StrategyAttributeCountryName["Montenegro"] = "montenegro";
    StrategyAttributeCountryName["Morocco"] = "morocco";
    StrategyAttributeCountryName["Mozambique"] = "mozambique";
    StrategyAttributeCountryName["Myanmar"] = "myanmar";
    StrategyAttributeCountryName["Namibia"] = "namibia";
    StrategyAttributeCountryName["Nauru"] = "nauru";
    StrategyAttributeCountryName["Nepal"] = "nepal";
    StrategyAttributeCountryName["Netherlands"] = "netherlands";
    StrategyAttributeCountryName["NewZealand"] = "new_zealand";
    StrategyAttributeCountryName["Nicaragua"] = "nicaragua";
    StrategyAttributeCountryName["Niger"] = "niger";
    StrategyAttributeCountryName["Nigeria"] = "nigeria";
    StrategyAttributeCountryName["NorthMacedonia"] = "north_macedonia";
    StrategyAttributeCountryName["Norway"] = "norway";
    StrategyAttributeCountryName["Oman"] = "oman";
    StrategyAttributeCountryName["Pakistan"] = "pakistan";
    StrategyAttributeCountryName["Palau"] = "palau";
    StrategyAttributeCountryName["Panama"] = "panama";
    StrategyAttributeCountryName["PapuaNewGuinea"] = "papua_new_guinea";
    StrategyAttributeCountryName["Paraguay"] = "paraguay";
    StrategyAttributeCountryName["Peru"] = "peru";
    StrategyAttributeCountryName["Philippines"] = "philippines";
    StrategyAttributeCountryName["Poland"] = "poland";
    StrategyAttributeCountryName["Portugal"] = "portugal";
    StrategyAttributeCountryName["Qatar"] = "qatar";
    StrategyAttributeCountryName["Romania"] = "romania";
    StrategyAttributeCountryName["Russia"] = "russia";
    StrategyAttributeCountryName["Rwanda"] = "rwanda";
    StrategyAttributeCountryName["SaintKittsAndNevis"] = "saint_kitts_and_nevis";
    StrategyAttributeCountryName["SaintLucia"] = "saint_lucia";
    StrategyAttributeCountryName["SaintVincentAndTheGrenadines"] = "saint_vincent_and_the_grenadines";
    StrategyAttributeCountryName["Samoa"] = "samoa";
    StrategyAttributeCountryName["SanMarino"] = "san_marino";
    StrategyAttributeCountryName["SaoTomeAndPrincipe"] = "sao_tome_and_principe";
    StrategyAttributeCountryName["SaudiArabia"] = "saudi_arabia";
    StrategyAttributeCountryName["Senegal"] = "senegal";
    StrategyAttributeCountryName["Serbia"] = "serbia";
    StrategyAttributeCountryName["Seychelles"] = "seychelles";
    StrategyAttributeCountryName["SierraLeone"] = "sierra_leone";
    StrategyAttributeCountryName["Singapore"] = "singapore";
    StrategyAttributeCountryName["Slovakia"] = "slovakia";
    StrategyAttributeCountryName["Slovenia"] = "slovenia";
    StrategyAttributeCountryName["SolomonIslands"] = "solomon_islands";
    StrategyAttributeCountryName["Somalia"] = "somalia";
    StrategyAttributeCountryName["SouthAfrica"] = "south_africa";
    StrategyAttributeCountryName["Spain"] = "spain";
    StrategyAttributeCountryName["SriLanka"] = "sri_lanka";
    StrategyAttributeCountryName["Sudan"] = "sudan";
    StrategyAttributeCountryName["SudanSouth"] = "sudan_south";
    StrategyAttributeCountryName["Suriname"] = "suriname";
    StrategyAttributeCountryName["Sweden"] = "sweden";
    StrategyAttributeCountryName["Switzerland"] = "switzerland";
    StrategyAttributeCountryName["Syria"] = "syria";
    StrategyAttributeCountryName["Taiwan"] = "taiwan";
    StrategyAttributeCountryName["Tajikistan"] = "tajikistan";
    StrategyAttributeCountryName["Tanzania"] = "tanzania";
    StrategyAttributeCountryName["Thailand"] = "thailand";
    StrategyAttributeCountryName["Togo"] = "togo";
    StrategyAttributeCountryName["Tonga"] = "tonga";
    StrategyAttributeCountryName["TrinidadAndTobago"] = "trinidad_and_tobago";
    StrategyAttributeCountryName["Tunisia"] = "tunisia";
    StrategyAttributeCountryName["Turkey"] = "turkey";
    StrategyAttributeCountryName["Turkmenistan"] = "turkmenistan";
    StrategyAttributeCountryName["Tuvalu"] = "tuvalu";
    StrategyAttributeCountryName["Uganda"] = "uganda";
    StrategyAttributeCountryName["Ukraine"] = "ukraine";
    StrategyAttributeCountryName["UnitedArabEmirates"] = "united_arab_emirates";
    StrategyAttributeCountryName["UnitedKingdom"] = "united_kingdom";
    StrategyAttributeCountryName["UnitedStates"] = "united_states";
    StrategyAttributeCountryName["Uruguay"] = "uruguay";
    StrategyAttributeCountryName["Uzbekistan"] = "uzbekistan";
    StrategyAttributeCountryName["Vanuatu"] = "vanuatu";
    StrategyAttributeCountryName["VaticanCity"] = "vatican_city";
    StrategyAttributeCountryName["Venezuela"] = "venezuela";
    StrategyAttributeCountryName["Vietnam"] = "vietnam";
    StrategyAttributeCountryName["Yemen"] = "yemen";
    StrategyAttributeCountryName["Zambia"] = "zambia";
    StrategyAttributeCountryName["Zimbabwe"] = "zimbabwe";
})(StrategyAttributeCountryName || (StrategyAttributeCountryName = {}));
//# sourceMappingURL=strategy-attribute-country-name.js.map